// extracted by mini-css-extract-plugin
module.exports = {"modal":"ErrorStateModal-module__modal--bsJcJ","content":"ErrorStateModal-module__content--2VGmY","footer":"ErrorStateModal-module__footer--RlJKj"};